module.exports = __webpack_public_path__ + "norbotest.png?cee046f6aea5254a98b74f266233c50e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/norbotest.png
// module id = 126
// module chunks = 0